<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CRenderFunction flat :content-to-render="sidebarItems"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import {getSidebarNav} from "@/containers/_nav";
import { ActiveUser } from '@/services/user';

export default {
  name: 'TheSidebar',
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    },
    currentCampaign() {
      return this.$route.params.campaign_id === this.$store.state.campaign?.id
          ? this.$store.state.campaign
          : null
    },
    sidebarItems() {
      const showMail = this.$route.name === "CampaignMailTemplate" ;
      return getSidebarNav(this.$route, this.currentCampaign, showMail, ActiveUser.get());
    },
  }
}
</script>

<style lang="scss">
  .top-navbar-spacer {
    background-color: $primary;
    margin: 0;
    height: 45px;
  }
  .c-sidebar-nav-link {
    text-wrap: wrap;
  }
  .c-sidebar {
    background-color: #203764;
  }

  .hide-toggler.c-sidebar-nav-dropdown.c-show > .c-sidebar-nav-dropdown-toggle::after {
    display: none !important;
  }

  .c-sidebar .c-sidebar-nav-dropdown.c-show {
    background-color: unset;
  }

  .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
    padding-left: 36px !important;
  }

  .c-sidebar-nav-dropdown.c-show.dropdown-shown.hide-toggler.item-active {
    .router-link-active {
      font-weight: bold;
      background-color: rgba(255, 255, 255, 0.05);
    }
  }
</style>
